import React from "react";

//Component===============================
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import FormLabel from "@material-ui/core/FormLabel";
import TextField from '@material-ui/core/TextField';
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

//ICON ===============================
import SendIcon from "@material-ui/icons/Send";
import PriorityHighIcon from "@material-ui/icons/PriorityHigh";

import classNames from 'classnames';
import ConfigHost from "ConfigHost"
import {thaiBath} from "ConvertFormat"
import { APIGet,APIPost } from "APIRequest"
import URL from "UrlServer"
import * as Alert from "alertService"

//Style===============================
import withStyles from "@material-ui/core/styles/withStyles";
// import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";

const styles = {
    ...regularFormsStyle,
    container2: {
        paddingLeft: 16,
        paddingRight: 16,
        display: 'flex',
        flexWrap: 'wrap',
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    dense: {
      marginTop: 16,
    },
    mt16: {
      marginTop: 16,
    },
    mt20: {
      marginTop: 20,
    },
    menu: {
      width: 200,
    },
    marginRight: {
        float: "right !important"
    },
}
class ForTestPage extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
          API_METHOD:"GET",
          API_PATH:"api/Ranking/callALlScheduleRanking",
          DATA_RES:"",
        }
      }
    componentDidMount(){
        // Alert.Loading()
        // API("OPTIONS",URL.URL_GET_LISTS_MONITOR_TOKEN,null,({datas})=>{
        // API("GET",URL.URL_GET_LISTS_MONITOR_TOKEN,null,({datas})=>{
        //     this.setState({tokenLists:datas},()=>{
        //         Alert.LoadingClose()
        //     })
        // })
    }
    sendAPI = event => {
        console.log(">>>>> sendAPI",this.state.API_METHOD,this.state.API_PATH );
        Alert.Loading(true)
        APIGet(this.state.API_PATH,(datas)=>{
            this.setState({DATA_RES:JSON.stringify(datas)},()=>{
                // Alert.LoadingClose()
            })
        },(data_err)=>{
            this.setState({DATA_RES:JSON.stringify(data_err)},()=>{
            })
        })

    };
   
    // handleChangeNameVal = event => {
    //     // console.log(">>>>> " + event.target.name , event.target.value );
    //     this.setState({ 
    //         [event.target.name]: event.target.value ,
    //     },()=>{
    //     });

    // };
   
    handleChangeName = event => {
        console.log("handleChangeName >>>> ",event.target.name,event.target.value );
        this.setState({ 
            [event.target.name]: event.target.value ,
            dataWaitToSave:false
        },()=>{
        });
    };
    render() {
        const { classes } = this.props;
        
        return (
            <div className={classes.container2 + " fullWidth"}>
                <Card>
                    <CardBody>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={11}>
                                <h4>ทดสอบยิงค่า Dashboard</h4>
                            </GridItem>
                            <GridItem xs={12} sm={12} md={11}>
                                
                            </GridItem>
                            <GridItem xs={2}>
                                <TextField
                                    id="outlined-dense"
                                    label="METHOD"
                                    value={this.state.API_METHOD}
                                    className={classNames(classes.textField, classes.dense)}
                                    margin="dense"
                                    variant="outlined"
                                    fullWidth
                                    name="API_METHOD"
                                    onChange={this.handleChangeName}
                                />
                            </GridItem>
                            <GridItem xs={10}>
                                <TextField
                                    id="outlined-dense"
                                    label="http://172.22.103.41:3001/:PATH"
                                    value={this.state.API_PATH}
                                    className={classNames(classes.textField, classes.dense)}
                                    margin="dense"
                                    variant="outlined"
                                    fullWidth
                                    name="API_PATH"
                                    onChange={this.handleChangeName}
                                />
                            </GridItem>
                            <GridItem xs={12}>
                                <Button color="info" size="md" 
                                onClick={(e)=>this.sendAPI()}
                                >
                                    <SendIcon className={classes.icons} /> เรียก API
                                </Button>
                            </GridItem>
                        </GridContainer>
                    </CardBody>
                </Card>
                <Card>
                    <CardBody>
                        <GridContainer justify="center">
                            <GridItem xs={12} sm={12} md={11}>
                                {this.state.DATA_RES}
                            </GridItem>
                        </GridContainer>
                    </CardBody>
                </Card>
            </div>
        );
    }
}

export default withStyles(styles)(ForTestPage);
